// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/profilebg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets//icons/tick.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile_bg {
    position: relative;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    z-index: 2;
    padding-top: 1rem;
}

/* .subscription_icon {
    position: absolute;
    top: 2rem;
    left: 42rem;
} */

/* .editprofile_icon {
    position: absolute;
    top: 0rem;
    left: 50rem;
} */

.subscription_icon {
    position: absolute;
    bottom: -45px;
}

.editprofile_icon {
    position: absolute;
    bottom: 30px;
    right: -17px;
}

.profilePicBox {
    border-radius: 100%;
    height: 165px;
    width: 165px;
    position: relative;
    top: -130px;
    left: 50%;
    transform: translateX(-50%);
}

.userPicBox {
    border-radius: 100%;
    height: 165px;
    width: 165px;
    overflow: hidden;
}

/* position for editing icon name */
/* .editname {
    position: relative;
    top: -2.5rem;
    left: 25rem;
} */
.editname,
.editphone,
.editemail,
.save_cancelname,
.save_cancelphone,
.save_cancelemail {
    position: absolute;
    top: 15px;
    right: 15px;
}

/* .save_cancelname {
    position: relative;
    top: -3rem;
    left: 22rem;
} */

/* position for editing icon phone */
/* .editphone {
    position: relative;
    top: -2.5rem;
    left: 25rem;
} */

/* .save_cancelphone {
    position: relative;
    top: -3rem;
    left: 22rem;
} */

/* position for editing icon email */
/* .editemail {
    position: relative;
    top: -2.5rem;
    left: 25rem;
} */

/* .save_cancelemail {
    position: relative;
    top: -3rem;
    left: 22rem;
} */

.disabled {
    color: #5A5A5A !important;
}

/* header for offcanvas and modal */

.modal_header {
    width: auto;
    height: auto;
    background: #1B9075;
}

.modal_header .head {
    font-family: Lexend;
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
    text-align: left;
    color: #ffffff;
}

.modal_body .subText {
    font-family: Manrope;
    font-size: 14px;
    font-weight: 500;
    line-height: 24px;
    text-align: left;
    color: #000;
}

.modal_body .reviewName {
    font-family: Manrope;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    text-align: left;
    color: #000;
}

.modal_body .reviewService {
    font-family: Manrope;
    font-size: 14px;
    font-weight: 500;
    line-height: 24px;
    text-align: left;
    color: #1B9075;
}

.modal_body .ratingNum {
    font-family: Manrope;
    font-size: 14px;
    font-weight: 500;
    line-height: 24px;
    text-align: left;
    color: #1B9075;
}

.modal_body .bookingdetails_header {
    font-family: Manrope;
    font-size: 16px;
    font-weight: 700;
    line-height: 18px;
    text-align: left;
    color: #1B9075;
}

.modal_body .firstHead {
    font-family: Lexend;
    font-size: 12px;
    font-weight: 600;
    line-height: 16px;
    text-align: left;
    color: #38385E;
}

.modal_body .secondHead {
    font-family: Lexend;
    font-size: 14px;
    font-weight: 300;
    line-height: 24px;
    text-align: left;
    color: #38385E;
}

.modal_body .block {
    border-bottom: 1px solid #DCDCDC;
}


/* breadcrump */
.breadcrump .heading_first {
    font-family: Manrope;
    font-size: 16px;
    font-weight: 500;
    line-height: 16px;
    text-align: left;
    color: #000;
}

.breadcrump .heading_second {
    font-family: Manrope;
    font-size: 16px;
    font-weight: 600;
    line-height: 16px;
    text-align: left;
    color: #1B9075;
}

/* review post style */

.review .reviewProfilePic {
    position: absolute;
    top: 12rem;
    left: 43rem;
}

.review .textarea {
    font-family: Manrope;
    font-size: 16px;
    font-weight: 400;
    line-height: 16px;
    text-align: left;
    color: #000;
    border-bottom: 0 !important;
    box-shadow: 0 0 0 0 !important;
    border-top: 1px solid #000 !important;
    border-left: 1px solid #000 !important;
    border-right: 1px solid #000 !important;
    border-top-left-radius: 4px !important;
    border-top-right-radius: 4px !important;
}

.review .predefinedReview {
    border-bottom: 1px solid #000 !important;
    border-left: 1px solid #000 !important;
    border-right: 1px solid #000 !important;
    border-bottom-left-radius: 4px !important;
    border-bottom-right-radius: 4px !important;
}

.review .bgReviewProfile {
    width: auto;
    height: 118px;
    background-color: #1B9075;
}

.review .text_first {
    font-family: Manrope;
    font-size: 20px;
    font-weight: 600;
    line-height: 30px;
    text-align: center;
    color: #38385E;
}

.review .text_second {
    font-family: Manrope;
    font-size: 20px;
    font-weight: 600;
    line-height: 30px;
    text-align: center;
    color: #1B9075;
}

.review .rating {
    box-shadow: 0px 2px 32px 0px #0000001A;
    background-color: #fff;

    width: 296px;
    height: 55.4px;
    border-radius: 35.5px;
}


/* address css */
.addressHeadBg {
    background: #F1FFFC;
    border-radius: 4px, 4px, 0px, 0px;
}

.addressBodyBg {
    background: #FFFFFF;
}

.addressBoxHead {
    font-family: Manrope;
    font-size: 11px;
    font-weight: 600;
    line-height: 15.03px;
    text-align: left;
    color: #1B9075;
}

.addresssub_head {
    font-family: Lexend;
    font-size: 11px;
    font-weight: 300;
    line-height: 13.75px;
    text-align: left;
    color: #1B9075;
}

.address_border {
    border: 1px solid #E9E9E9;
}

.addresssub_text {
    font-family: Lexend;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    text-align: left;
    color: #13171B;
}

.addAddressBtn {
    border: 1px solid #1B9075;
    border-radius: 4px;
    background: #F1FFFC;
}

.subtext {
    font-family: Lexend;
    font-size: 14px;
    font-weight: 300;
    line-height: 24px;
    text-align: left;
    color: #000;
}

.subText1 {
    font-family: Manrope;
    font-size: 12px;
    font-weight: 400;
    line-height: 16.39px;
    text-align: left;
    color: #fff;
}

.subtext2 {
    font-family: Manrope;
    font-size: 14px;
    font-weight: 600;
    line-height: 19.12px;
    /* text-align: left; */
    color: #5C5C5C;

}

.tabtitle {
    font-family: Lexend;
    font-size: 16px;
    font-weight: 400;
    line-height: 20px;
    text-align: left;
    color: #000000;
}

.tabtitlebg {
    border: 1px solid #C2C2C2;
    background-color: #fff;
}

.logout {
    border: 1px solid #1B9075;
    background-color: #fff;
    color: #1B9075;
    font-family: Poppins;
    font-size: 14px;
    font-weight: 600;
    line-height: 24px;
    text-align: center;

}

/* contact form */

.contactform {
    margin-top: -175px;
}

/* about us */
.aboutus {
    margin-top: -200px;
}

/* .aboutus {
    position: absolute;
    top: -200px;
    left: 50%;
    transform: translateX(-50%);
    width: 87%;
}
.benefitsection {
    margin-top: 37rem;
} */

/* for input checked */

input[type="checkbox"]:checked {
    color: #1B9075;
}


.text_first {
    font-family: Manrope;
    font-size: 20px;
    font-weight: 600;
    line-height: 30px;
    text-align: center;
    color: #38385E;
}

.text_second {
    font-family: Manrope;
    font-size: 20px;
    font-weight: 600;
    line-height: 30px;
    text-align: center;
    color: #1B9075;
}

/* notification offcanvas */

.offcanvas_body .offcanvas_head {
    background-color: #1B9075;
    height: 80px;
}

.offcanvas_body .offcanvas_head .heading {
    color: #fff;
}


/* subscription */

.big_text {
    background: #FFFFFF;
    border: 2px solid #1B9075;
    padding: 1rem;
    box-shadow: 0px 2px 23px 0px #00000040;
    border-radius: 9px;

    font-family: Manrope;
    font-size: 36px;
    font-weight: 800;
    line-height: 49.18px;
    text-align: center;
    color: #1B9075;

}

.subsShadow {
    box-shadow: 0px 2px 100px 0px #00000026;
}

.boxHeight {
    height: 457px !important;
}

.basic_subscription {
    margin-right: -3rem;
    /* width: 356px; */
    /* height: 457px; */
    height: auto;
    background: #FFFFFF;
}

.crownpositionBasic {
    position: absolute;
    top: -3rem;
    right: 38rem;
}

.basic_subscription .header {
    /* width: 404px; */
    height: 145px;

    background: linear-gradient(180deg, #837D89 49.01%, #585066 100%);
}

.advance_subscription {
    /* width: 404px; */
    /* height: 543px; */
    height: auto;

    background: #FFFFFF;
}

.crownpositionPremium {
    position: absolute;
    top: -3rem;
    right: -3rem;
}

.advance_subscription .header {
    /* width: 404px; */
    height: 145px;
    background: linear-gradient(180deg, #E6B344 49.01%, #D09008 100%);
}

.subscribed .subscribed_header {
    /* width: 1136px; */
    height: 103px;
    background: linear-gradient(180deg, #E6B344 49.01%, #D09008 100%);
}

.subscribed .subscribed_text {
    width: 243px;
    height: 52px;
    border-radius: 26px;
    background: #BE850B;
    font-family: Manrope;
    font-size: 18px;
    font-weight: 700;
    line-height: 24.59px;
    text-align: center;
    color: #fff;
}

.benefits p {
    font-family: Lexend;
    font-size: 14px;
    font-weight: 300;
    line-height: 24px;
    text-align: left;
    color: #000;
}

.benefits p::before {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    width: 20px;
    height: auto;
    display: inline-block;
}


/* notification  */
.notification_box {
    /* width: 470px; */
    height: 98px;
    border-radius: 6px;
    background: #FFFFFF;
    border: 1px solid #1B9075;
    box-shadow: 0px 2px 22px 0px #0000001A;
    padding: 0.5rem;
}

/* slick slider css */
.slick-slider {
    margin: 1rem 2rem;
}

.slick-slider .slick-next {
    border: none;
    cursor: pointer;
    display: block;
    font-size: 0;
    height: 20px;
    line-height: 0;
    padding: 0;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 20px;
}

.slick-slider .slick-next::before {
    /* color: #fff; */
    font-size: 20px;
    line-height: 1;
    opacity: .75;
    color: #1B9075 !important;
    content: "→";
}

.slick-slider .slick-prev {
    border: none;
    cursor: pointer;
    display: block;
    font-size: 0;
    height: 20px;
    line-height: 0;
    padding: 0;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 20px;
    left: -25px;
}

.slick-slider .slick-prev::before {
    /* color: #fff; */
    font-size: 20px;
    line-height: 1;
    opacity: .75;
    color: #1B9075 !important;
    content: "←";
}

.carousel-item {
    background-color: aliceblue;
    padding: 1rem;
}

@media all and (max-width:768px) {
    .benefitList img {
        width: 20px;
    }

    .testimonial_body .testimonial_text p {
        font-size: 15px;
    }

    .blog_section h2,
    .testimonials_section h2 {
        font-size: 22px !important;
        text-align: center;
    }

    .logoImageBox img {
        width: 145px;
    }

    .contactform .fieldGroup {
        flex-flow: column;
    }

    .contactform .fieldGroup>div {
        margin: 0 0 15px 0 !important;
    }

    .basic_subscription {
        margin-right: 0rem;
    }
}

@media all and (max-width:575px) {
    .blog_section .blog_section_card .blog_card h3 {
        font-size: 15px !important;
        line-height: normal;
    }

    .basic_subscription {
        margin-right: 0rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/postlogin/styles.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,yDAAmD;IACnD,sBAAsB;IACtB,2BAA2B;IAC3B,4BAA4B;IAC5B,UAAU;IACV,iBAAiB;AACrB;;AAEA;;;;GAIG;;AAEH;;;;GAIG;;AAEH;IACI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,YAAY;IACZ,gBAAgB;AACpB;;AAEA,mCAAmC;AACnC;;;;GAIG;AACH;;;;;;IAMI,kBAAkB;IAClB,SAAS;IACT,WAAW;AACf;;AAEA;;;;GAIG;;AAEH,oCAAoC;AACpC;;;;GAIG;;AAEH;;;;GAIG;;AAEH,oCAAoC;AACpC;;;;GAIG;;AAEH;;;;GAIG;;AAEH;IACI,yBAAyB;AAC7B;;AAEA,mCAAmC;;AAEnC;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,gCAAgC;AACpC;;;AAGA,eAAe;AACf;IACI,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA,sBAAsB;;AAEtB;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;AACf;;AAEA;IACI,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;IACX,2BAA2B;IAC3B,8BAA8B;IAC9B,qCAAqC;IACrC,sCAAsC;IACtC,uCAAuC;IACvC,sCAAsC;IACtC,uCAAuC;AAC3C;;AAEA;IACI,wCAAwC;IACxC,sCAAsC;IACtC,uCAAuC;IACvC,yCAAyC;IACzC,0CAA0C;AAC9C;;AAEA;IACI,WAAW;IACX,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,sCAAsC;IACtC,sBAAsB;;IAEtB,YAAY;IACZ,cAAc;IACd,qBAAqB;AACzB;;;AAGA,gBAAgB;AAChB;IACI,mBAAmB;IACnB,iCAAiC;AACrC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,sBAAsB;IACtB,cAAc;;AAElB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,cAAc;IACd,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;;AAEtB;;AAEA,iBAAiB;;AAEjB;IACI,kBAAkB;AACtB;;AAEA,aAAa;AACb;IACI,kBAAkB;AACtB;;AAEA;;;;;;;;;GASG;;AAEH,sBAAsB;;AAEtB;IACI,cAAc;AAClB;;;AAGA;IACI,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;AAClB;;AAEA,2BAA2B;;AAE3B;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;;AAGA,iBAAiB;;AAEjB;IACI,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,sCAAsC;IACtC,kBAAkB;;IAElB,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAClB,cAAc;;AAElB;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,aAAa;;IAEb,iEAAiE;AACrE;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;;IAEZ,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,iEAAiE;AACrE;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,iEAAiE;AACrE;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,gDAA0C;IAC1C,WAAW;IACX,YAAY;IACZ,qBAAqB;AACzB;;;AAGA,kBAAkB;AAClB;IACI,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,sCAAsC;IACtC,eAAe;AACnB;;AAEA,qBAAqB;AACrB;IACI,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,cAAc;IACd,YAAY;IACZ,YAAY;IACZ,cAAc;IACd,UAAU;IACV,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,YAAY;IACZ,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,cAAc;IACd,YAAY;IACZ,YAAY;IACZ,cAAc;IACd,UAAU;IACV,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,WAAW;IACX,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,YAAY;IACZ,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,2BAA2B;IAC3B,aAAa;AACjB;;AAEA;IACI;QACI,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;;IAEA;;QAEI,0BAA0B;QAC1B,kBAAkB;IACtB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,0BAA0B;QAC1B,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;IACtB;AACJ","sourcesContent":[".profile_bg {\n    position: relative;\n    background-image: url(\"../../assets/profilebg.png\");\n    background-size: cover;\n    background-position: center;\n    background-repeat: no-repeat;\n    z-index: 2;\n    padding-top: 1rem;\n}\n\n/* .subscription_icon {\n    position: absolute;\n    top: 2rem;\n    left: 42rem;\n} */\n\n/* .editprofile_icon {\n    position: absolute;\n    top: 0rem;\n    left: 50rem;\n} */\n\n.subscription_icon {\n    position: absolute;\n    bottom: -45px;\n}\n\n.editprofile_icon {\n    position: absolute;\n    bottom: 30px;\n    right: -17px;\n}\n\n.profilePicBox {\n    border-radius: 100%;\n    height: 165px;\n    width: 165px;\n    position: relative;\n    top: -130px;\n    left: 50%;\n    transform: translateX(-50%);\n}\n\n.userPicBox {\n    border-radius: 100%;\n    height: 165px;\n    width: 165px;\n    overflow: hidden;\n}\n\n/* position for editing icon name */\n/* .editname {\n    position: relative;\n    top: -2.5rem;\n    left: 25rem;\n} */\n.editname,\n.editphone,\n.editemail,\n.save_cancelname,\n.save_cancelphone,\n.save_cancelemail {\n    position: absolute;\n    top: 15px;\n    right: 15px;\n}\n\n/* .save_cancelname {\n    position: relative;\n    top: -3rem;\n    left: 22rem;\n} */\n\n/* position for editing icon phone */\n/* .editphone {\n    position: relative;\n    top: -2.5rem;\n    left: 25rem;\n} */\n\n/* .save_cancelphone {\n    position: relative;\n    top: -3rem;\n    left: 22rem;\n} */\n\n/* position for editing icon email */\n/* .editemail {\n    position: relative;\n    top: -2.5rem;\n    left: 25rem;\n} */\n\n/* .save_cancelemail {\n    position: relative;\n    top: -3rem;\n    left: 22rem;\n} */\n\n.disabled {\n    color: #5A5A5A !important;\n}\n\n/* header for offcanvas and modal */\n\n.modal_header {\n    width: auto;\n    height: auto;\n    background: #1B9075;\n}\n\n.modal_header .head {\n    font-family: Lexend;\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 24px;\n    text-align: left;\n    color: #ffffff;\n}\n\n.modal_body .subText {\n    font-family: Manrope;\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 24px;\n    text-align: left;\n    color: #000;\n}\n\n.modal_body .reviewName {\n    font-family: Manrope;\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 24px;\n    text-align: left;\n    color: #000;\n}\n\n.modal_body .reviewService {\n    font-family: Manrope;\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 24px;\n    text-align: left;\n    color: #1B9075;\n}\n\n.modal_body .ratingNum {\n    font-family: Manrope;\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 24px;\n    text-align: left;\n    color: #1B9075;\n}\n\n.modal_body .bookingdetails_header {\n    font-family: Manrope;\n    font-size: 16px;\n    font-weight: 700;\n    line-height: 18px;\n    text-align: left;\n    color: #1B9075;\n}\n\n.modal_body .firstHead {\n    font-family: Lexend;\n    font-size: 12px;\n    font-weight: 600;\n    line-height: 16px;\n    text-align: left;\n    color: #38385E;\n}\n\n.modal_body .secondHead {\n    font-family: Lexend;\n    font-size: 14px;\n    font-weight: 300;\n    line-height: 24px;\n    text-align: left;\n    color: #38385E;\n}\n\n.modal_body .block {\n    border-bottom: 1px solid #DCDCDC;\n}\n\n\n/* breadcrump */\n.breadcrump .heading_first {\n    font-family: Manrope;\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 16px;\n    text-align: left;\n    color: #000;\n}\n\n.breadcrump .heading_second {\n    font-family: Manrope;\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 16px;\n    text-align: left;\n    color: #1B9075;\n}\n\n/* review post style */\n\n.review .reviewProfilePic {\n    position: absolute;\n    top: 12rem;\n    left: 43rem;\n}\n\n.review .textarea {\n    font-family: Manrope;\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 16px;\n    text-align: left;\n    color: #000;\n    border-bottom: 0 !important;\n    box-shadow: 0 0 0 0 !important;\n    border-top: 1px solid #000 !important;\n    border-left: 1px solid #000 !important;\n    border-right: 1px solid #000 !important;\n    border-top-left-radius: 4px !important;\n    border-top-right-radius: 4px !important;\n}\n\n.review .predefinedReview {\n    border-bottom: 1px solid #000 !important;\n    border-left: 1px solid #000 !important;\n    border-right: 1px solid #000 !important;\n    border-bottom-left-radius: 4px !important;\n    border-bottom-right-radius: 4px !important;\n}\n\n.review .bgReviewProfile {\n    width: auto;\n    height: 118px;\n    background-color: #1B9075;\n}\n\n.review .text_first {\n    font-family: Manrope;\n    font-size: 20px;\n    font-weight: 600;\n    line-height: 30px;\n    text-align: center;\n    color: #38385E;\n}\n\n.review .text_second {\n    font-family: Manrope;\n    font-size: 20px;\n    font-weight: 600;\n    line-height: 30px;\n    text-align: center;\n    color: #1B9075;\n}\n\n.review .rating {\n    box-shadow: 0px 2px 32px 0px #0000001A;\n    background-color: #fff;\n\n    width: 296px;\n    height: 55.4px;\n    border-radius: 35.5px;\n}\n\n\n/* address css */\n.addressHeadBg {\n    background: #F1FFFC;\n    border-radius: 4px, 4px, 0px, 0px;\n}\n\n.addressBodyBg {\n    background: #FFFFFF;\n}\n\n.addressBoxHead {\n    font-family: Manrope;\n    font-size: 11px;\n    font-weight: 600;\n    line-height: 15.03px;\n    text-align: left;\n    color: #1B9075;\n}\n\n.addresssub_head {\n    font-family: Lexend;\n    font-size: 11px;\n    font-weight: 300;\n    line-height: 13.75px;\n    text-align: left;\n    color: #1B9075;\n}\n\n.address_border {\n    border: 1px solid #E9E9E9;\n}\n\n.addresssub_text {\n    font-family: Lexend;\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 20px;\n    text-align: left;\n    color: #13171B;\n}\n\n.addAddressBtn {\n    border: 1px solid #1B9075;\n    border-radius: 4px;\n    background: #F1FFFC;\n}\n\n.subtext {\n    font-family: Lexend;\n    font-size: 14px;\n    font-weight: 300;\n    line-height: 24px;\n    text-align: left;\n    color: #000;\n}\n\n.subText1 {\n    font-family: Manrope;\n    font-size: 12px;\n    font-weight: 400;\n    line-height: 16.39px;\n    text-align: left;\n    color: #fff;\n}\n\n.subtext2 {\n    font-family: Manrope;\n    font-size: 14px;\n    font-weight: 600;\n    line-height: 19.12px;\n    /* text-align: left; */\n    color: #5C5C5C;\n\n}\n\n.tabtitle {\n    font-family: Lexend;\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 20px;\n    text-align: left;\n    color: #000000;\n}\n\n.tabtitlebg {\n    border: 1px solid #C2C2C2;\n    background-color: #fff;\n}\n\n.logout {\n    border: 1px solid #1B9075;\n    background-color: #fff;\n    color: #1B9075;\n    font-family: Poppins;\n    font-size: 14px;\n    font-weight: 600;\n    line-height: 24px;\n    text-align: center;\n\n}\n\n/* contact form */\n\n.contactform {\n    margin-top: -175px;\n}\n\n/* about us */\n.aboutus {\n    margin-top: -200px;\n}\n\n/* .aboutus {\n    position: absolute;\n    top: -200px;\n    left: 50%;\n    transform: translateX(-50%);\n    width: 87%;\n}\n.benefitsection {\n    margin-top: 37rem;\n} */\n\n/* for input checked */\n\ninput[type=\"checkbox\"]:checked {\n    color: #1B9075;\n}\n\n\n.text_first {\n    font-family: Manrope;\n    font-size: 20px;\n    font-weight: 600;\n    line-height: 30px;\n    text-align: center;\n    color: #38385E;\n}\n\n.text_second {\n    font-family: Manrope;\n    font-size: 20px;\n    font-weight: 600;\n    line-height: 30px;\n    text-align: center;\n    color: #1B9075;\n}\n\n/* notification offcanvas */\n\n.offcanvas_body .offcanvas_head {\n    background-color: #1B9075;\n    height: 80px;\n}\n\n.offcanvas_body .offcanvas_head .heading {\n    color: #fff;\n}\n\n\n/* subscription */\n\n.big_text {\n    background: #FFFFFF;\n    border: 2px solid #1B9075;\n    padding: 1rem;\n    box-shadow: 0px 2px 23px 0px #00000040;\n    border-radius: 9px;\n\n    font-family: Manrope;\n    font-size: 36px;\n    font-weight: 800;\n    line-height: 49.18px;\n    text-align: center;\n    color: #1B9075;\n\n}\n\n.subsShadow {\n    box-shadow: 0px 2px 100px 0px #00000026;\n}\n\n.boxHeight {\n    height: 457px !important;\n}\n\n.basic_subscription {\n    margin-right: -3rem;\n    /* width: 356px; */\n    /* height: 457px; */\n    height: auto;\n    background: #FFFFFF;\n}\n\n.crownpositionBasic {\n    position: absolute;\n    top: -3rem;\n    right: 38rem;\n}\n\n.basic_subscription .header {\n    /* width: 404px; */\n    height: 145px;\n\n    background: linear-gradient(180deg, #837D89 49.01%, #585066 100%);\n}\n\n.advance_subscription {\n    /* width: 404px; */\n    /* height: 543px; */\n    height: auto;\n\n    background: #FFFFFF;\n}\n\n.crownpositionPremium {\n    position: absolute;\n    top: -3rem;\n    right: -3rem;\n}\n\n.advance_subscription .header {\n    /* width: 404px; */\n    height: 145px;\n    background: linear-gradient(180deg, #E6B344 49.01%, #D09008 100%);\n}\n\n.subscribed .subscribed_header {\n    /* width: 1136px; */\n    height: 103px;\n    background: linear-gradient(180deg, #E6B344 49.01%, #D09008 100%);\n}\n\n.subscribed .subscribed_text {\n    width: 243px;\n    height: 52px;\n    border-radius: 26px;\n    background: #BE850B;\n    font-family: Manrope;\n    font-size: 18px;\n    font-weight: 700;\n    line-height: 24.59px;\n    text-align: center;\n    color: #fff;\n}\n\n.benefits p {\n    font-family: Lexend;\n    font-size: 14px;\n    font-weight: 300;\n    line-height: 24px;\n    text-align: left;\n    color: #000;\n}\n\n.benefits p::before {\n    content: url(../../assets//icons/tick.svg);\n    width: 20px;\n    height: auto;\n    display: inline-block;\n}\n\n\n/* notification  */\n.notification_box {\n    /* width: 470px; */\n    height: 98px;\n    border-radius: 6px;\n    background: #FFFFFF;\n    border: 1px solid #1B9075;\n    box-shadow: 0px 2px 22px 0px #0000001A;\n    padding: 0.5rem;\n}\n\n/* slick slider css */\n.slick-slider {\n    margin: 1rem 2rem;\n}\n\n.slick-slider .slick-next {\n    border: none;\n    cursor: pointer;\n    display: block;\n    font-size: 0;\n    height: 20px;\n    line-height: 0;\n    padding: 0;\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    width: 20px;\n}\n\n.slick-slider .slick-next::before {\n    /* color: #fff; */\n    font-size: 20px;\n    line-height: 1;\n    opacity: .75;\n    color: #1B9075 !important;\n    content: \"→\";\n}\n\n.slick-slider .slick-prev {\n    border: none;\n    cursor: pointer;\n    display: block;\n    font-size: 0;\n    height: 20px;\n    line-height: 0;\n    padding: 0;\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    width: 20px;\n    left: -25px;\n}\n\n.slick-slider .slick-prev::before {\n    /* color: #fff; */\n    font-size: 20px;\n    line-height: 1;\n    opacity: .75;\n    color: #1B9075 !important;\n    content: \"←\";\n}\n\n.carousel-item {\n    background-color: aliceblue;\n    padding: 1rem;\n}\n\n@media all and (max-width:768px) {\n    .benefitList img {\n        width: 20px;\n    }\n\n    .testimonial_body .testimonial_text p {\n        font-size: 15px;\n    }\n\n    .blog_section h2,\n    .testimonials_section h2 {\n        font-size: 22px !important;\n        text-align: center;\n    }\n\n    .logoImageBox img {\n        width: 145px;\n    }\n\n    .contactform .fieldGroup {\n        flex-flow: column;\n    }\n\n    .contactform .fieldGroup>div {\n        margin: 0 0 15px 0 !important;\n    }\n\n    .basic_subscription {\n        margin-right: 0rem;\n    }\n}\n\n@media all and (max-width:575px) {\n    .blog_section .blog_section_card .blog_card h3 {\n        font-size: 15px !important;\n        line-height: normal;\n    }\n\n    .basic_subscription {\n        margin-right: 0rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
